export const LIST_CONTACTS = "listContacts";
export const CREATE_CONTACT = "createContact";
export const INVITE_CONTACTS = "inviteContacts";
export const UPDATE_CONTACT = "updateContact";
export const DELETE_CONTACT = "deleteContact";
export const REMOVE_CONTACT_INVITE = "removeCustomerInvite";
export const RESEND_CONTACT_INVITE = "resendCustomerInvite";
